import { render, staticRenderFns } from "./EditTrialModal.vue?vue&type=template&id=8bd3b418&scoped=true&"
import script from "./EditTrialModal.vue?vue&type=script&lang=js&"
export * from "./EditTrialModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTrialModal.vue?vue&type=style&index=0&id=8bd3b418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd3b418",
  null
  
)

export default component.exports